module.exports={"flag":"","geoJSON":{},"ISO":{},"provinces":["Ile du Lys","Ile Glorieuse"],"tld":[],"wiki":"http://en.wikipedia.org/wiki/glorioso_islands"}